import React from 'react';
import { StarIcon, PhoneIcon } from 'lucide-react';
export function TopBar() {
  return <div className="bg-brand-dark text-gray-300 py-3 px-4 text-sm font-medium border-b border-gray-800 sticky top-0 z-50" data-id="element-184">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-4" data-id="element-185">
        <a href="https://lancerservice.com" target="_blank" rel="noopener noreferrer" className="flex-shrink-0" data-id="element-186">
          <img src="https://lirp.cdn-website.com/f2cc6821/dms3rep/multi/opt/logo-1920w.png" alt="Lancer Auto Repair" className="h-14 w-auto" data-id="element-187" />
        </a>
        <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6 text-center" data-id="element-188">
          <div className="flex items-center gap-1.5" data-id="element-189">
            <div className="flex text-brand-gold" data-id="element-190">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-current" data-id="element-191" />)}
            </div>
            <span data-id="element-192"> 595+ reviews</span>
          </div>
          <span className="hidden sm:inline text-gray-600" data-id="element-193">•</span>
          <span className="hidden lg:inline" data-id="element-194">Mon–Fri 7:00am–5:00pm</span>
          <span className="hidden lg:inline text-gray-600" data-id="element-195">•</span>
          <span className="hidden lg:inline" data-id="element-196">270 E 8th St, St Paul, MN</span>
          <span className="hidden sm:inline text-gray-600" data-id="element-197">•</span>
          <a href="tel:6512240267" className="flex items-center gap-1.5 text-white hover:text-brand-accent transition-colors font-semibold" data-id="element-198">
            (651) 224-0267
          </a>
        </div>
      </div>
    </div>;
}